import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import Classes from './BundlePriceBlock.module.scss';

const BundlePriceBlock = ({ price }: { price: string | number }) => {
  const { t } = useI18nContext();
  return (
    <div>
      <span className={Classes.price}>{price}</span>
      <span className={Classes.priceFrequency}>{t('purchaseBundle.bundles.priceFrequencyWithoutDiscount')}</span>
    </div>
  );
};

export default BundlePriceBlock;
